import { bankAccountResponseSchema } from '@/api/me/bankAccountSchemas';
import {
  getFinancialDetailsResponseSchema,
  meResponseFISchema,
  meResponseSESchema,
  meResponseUKSchema,
  updateFinancialDetailsResponseSchema,
} from '@/api/me/schema';
import type { UpdateFinancialDetailsPayload } from '@/api/me/types';
import { apiRequest } from '@/api/utils/api';
import { getConfig } from '@/constants/config';
import { assertUnreachable } from '@/utils/typescript';

export const getMe = async () => {
  const country = getConfig().country;
  switch (country) {
    case 'SE':
      return apiRequest({ url: '/me', method: 'GET', schema: meResponseSESchema });
    case 'UK':
      return apiRequest({ url: '/me', method: 'GET', schema: meResponseUKSchema });
    case 'FI':
      return apiRequest({ url: '/me', method: 'GET', schema: meResponseFISchema });
    default:
      return assertUnreachable(country);
  }
};

export const getFinancialDetails = () =>
  apiRequest({ url: '/me/kalp', method: 'GET', schema: getFinancialDetailsResponseSchema });

export const updateFinancialDetails = (data: UpdateFinancialDetailsPayload) =>
  apiRequest({ url: '/me/kalp', method: 'PUT', schema: updateFinancialDetailsResponseSchema, data });

export const getBankAccount = () =>
  apiRequest({ url: '/me/bank-account', method: 'GET', schema: bankAccountResponseSchema });
